import React from 'react'
import { func } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Icon from '../../ui/icon/Icon'
import { messages } from '../messages'

const MobileHeader = ({ onResetFilters, cancelCallback }) => (
  <div className='ad-filter__mobile-header'>
    <Icon svg='cancel' onClick={cancelCallback} />
    <span className='ad-filter__mobile-title'><FormattedMessage {...messages.filters} /></span>

    <span onClick={onResetFilters} className='ad-filter__mobile-text'>
      {onResetFilters && <FormattedMessage {...messages.reset} />}
    </span>
  </div>
)

MobileHeader.propTypes = {
  onResetFilters: func,
  cancelCallback: func
}

export default MobileHeader